import React, { Component } from "react";

import { Row, Col, Button, Tabs, Card, Steps, Timeline, Avatar } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";

import { PlusCircleOutlined } from "@ant-design/icons";

import serviceOne from "../../Imgs/HomePage/OurServices/service1.svg";
import serviceTwo from "../../Imgs/HomePage/OurServices/service2.svg";
import serviceThree from "../../Imgs/HomePage/OurServices/service3.svg";
import serviceFour from "../../Imgs/HomePage/OurServices/service4.svg";
import serviceFive from "../../Imgs/HomePage/OurServices/service5.svg";
import serviceSix from "../../Imgs/HomePage/OurServices/service6.svg";
import serviceSeven from "../../Imgs/HomePage/OurServices/service7.svg";
import serviceEight from "../../Imgs/HomePage/OurServices/service8.svg";
import serviceNine from "../../Imgs/HomePage/OurServices/service9.svg";
import serviceTen from "../../Imgs/HomePage/OurServices/service10.svg";
import serviceEleven from "../../Imgs/HomePage/OurServices/service11.svg";
import serviceTwelve from "../../Imgs/HomePage/OurServices/service12.svg";

// CSS Files
import "../../Fonts/Fonts.css";
import "../../Statics/OurServices/OurServices.css";

import TextTabs from "./TextTabs.js";

const { TabPane } = Tabs;

function callback(key) {
  console.log(key);
}
const CustomTab = (props) => {
  return <img className="serviceTabImg" src={props.image} />;
};
const TabletMobileTab = (props) => {
  return (
    <Center>
      <img className="serviceTabImg" src={props.image} />
    </Center>
  );
};
const tpa = (
  <span>
    شرکت ایرانیان پوشش با راه اندازی شرکت ارزیابان خسارت و ریسک در حوزه بازرسی و
    نظارت بعنوان THIRD PARTY AUTHORITY برای بهبود کیفیت در حین استفاده ، وهمچنین
    کاهش تعداد خطا و سوءاستفادهای احتمالی، بطور دقیق نقاط ضعف فنی و فیزیکی در
    پروژها برای کارفرما انجام می دهد یکی از این خدمات برای شرکت های بیمه است که
    خسارت را به ارزیاب خسارت حقیقی یا حقوقی برون سپاری کرده است وبا اخذ قرارداد
    با ایرانیان پوشش بعنوان TPA (شخص سوم ) بر قرارداد نظارت می کند. یا بیمه
    گذاران حقوقی برای راست آزمای برآورد خسارت و تعیین تشخیص تعهد بیمه گر در
    قرارداد بیمه ای از خدمات این شرکت بزرگ ارزیابی استفاده می کنند .
  </span>
);
const counselingSystem = (
  <span>
    شرکت ارزیابان ایرانیان پوشش در جهت افزایش آگاهی و اعتماد سازی برای بیمه گران
    و بیمه گزاران در خصوص کاهش ریسک های بیمه گری و شناسایی بیمه نامه های موثر
    اقدام به خدمات مشاوره می نماید.
    <br />
    بررسی وظایف، مسئولیت‌ها و مهارت‌های مشاور بیمه
    <br />
    – استفاده از آمار و ارقام
    <br />
    – توضیح دقیق و شفاف سازی کلوز های بیمه
    <br />
    – در نظر گرفتن شرایط بیمه گر و بیمه گزاران برای کاهش ریسک
    <br />
    – تبیین محدودیت‌های بیمه نامه های صادر شده
    <br />
    – توضیح اموری که ممکن است باعث نادیده گرفتن تعهد شود
    <br />– ایجاد حس اعتماد در بیمه گزاران و افزایش ضریب نفوذ بیمه
  </span>
);
const research = (
  <span>
    از مهمترین مسائل صنعت بیمه که نهادهای درگیر در آن اعم از نهاد ناظر، بیمه
    گزاران، بیمه گران، واسطه ها، ارزیابان خسارت، حسابرسان،و به طور کلی تمامی
    بدنه و دست اندرکاران این عرصه در آن تاثیرگزار هستند، نحوه مواجه با پدیده ی
    شوم تقلب است.این موضوع از جمله عوامل توسعه نیافتگی بیمه ها است.از آنجایی که
    برخورد قضایی با متخلفان و متقلبان در حوزه مسئولیت و ماموریت بیمه گران و حتی
    بیمه مرکزی نیست، و متاسفانه در کشور دادگاه اختصاصی برای رسیدگی به پرونده های
    بیمه و نیروهای متخصص برای کشف این نوع تخلفات وجود ندارد در همین راستا
    ایرانیان پوشش بعد از شناسائی این خلل بزرگ با راه اندازی گروه افسران تحقیق
    بنام همیار بیمه شروع به فعالیت کرده است.افسران تحقیق همیار بیمه به عنوان
    همیار بیمه گران برای کشف، شناسایی و مقابله با جعل، تقلب و کلاهبرداری راه
    اندازی شده تا مصادیق این جرایم را مشخص و به بیمه گران آموزش دهد، همچنین با
    حفظ سوابق تخلفات و ارتباطات برخط با شرکتهای بیمه و استعلامات از سایر مراجع
    قضایی، انتظامی و پزشکی قانونی همانند پلی ارتباطی شکاف به وجود آمده میان آنها
    را پر و از عملکرد جزیره ای هرکدام جلوگیری خواهد نمود.
  </span>
);
const arbitration = (
  <span>
    شرکت ایرانیان پوشش نخستین و تنها موسسه مستقل برای ارائه خدمات تخصصی حقوقی
    بیمه گری است که به منظور تسهیل خدمات بیمه‌ای و کاهش سو استفاده‌های احتمالی
    از حقوق بیمه گران مشغول به فعالیت است؛ لذا فعالیت متمایز و با کیفیت این
    موسسه معتبر در اینجا مشخص می‌گردد که در پی حفظ ثبات و دوام شرکت‌های بیمه‌گر
    به عنوان فعالان اقتصادی تأثیر گزار در جریان زندگی مردم است ، از اهداف و اصول
    حرفه‌ای ما که سبب برتری غیر قابل قیاس با دیگران است به موارد زیر می‌توان
    اشاره کرد:
    <br />
    • پیگیری تخصصی پرونده‌های داوری شرکت‌های بیمه
    <br />
    – ارائه خدمات مناسب و با کیفیت به بیمه گران در راستای حفظ حقوق بیمه گران و
    رعایت اصول حرفه‌ای و اخلاق
    <br />
    • اعلام نظرات فنی و کارشناسی
    <br />
    – حفظ استقلال و بی طرفی در تمام موارد
    <br />
    – استفاده از تعرفه‌های مناسب و منطقی در مقایسه با نرخ رایج خدمات حقوقی در
    کشور
    <br />
    • خلاقیت و نوآوری
    <br />
    – ایجاد فضای مجازی برای ارتباط بیمه گران و کارشناسان و وکلاء پرونده
    <br />
    • بهره‌گیری از خدمات فرهیختگان حقوقی و صاحب‌نظران صنعت بیمه
    <br />
    – پایبندی به اصول حرفه ای و اخلاقی
    <br />
    – امانت داری و صیانت از حقوق و منافع بیمه گران
    <br />
    – بهره‌مندی از بخش‌های تخصصی ، ریکاوری ، افسران تحقیق بیمه، داوری و اندیشکده
    بیمه در راستای تحقق اهداف سازمانی
    <br />
    – فعال‌سازی کار تیمی و حفظ تعامل مستمر با بیمه گران
    <br />
    – تلاش برای کاهش پدیده بیمه گریزی با تحکیم روابط حقوقی بیمه گران و بیمه‌
    گزاران
    <br />
    • ارتقاء سرعت توأم با دقت در رسیدگی به پرونده‌های بیمه‌ای بیمه گران
    <br />
    – تلاش برای پیشگیری از تخلفات بیمه‌ای با تشکیل افسران تحقیق بیمه
    <br />
    • برخورداری از مشارکت فعالانه ، دلسوزانه و متعهدانه مجرب‌ترین اساتید، قضات
    بازنشسته و وکلای پایه یک دادگستری و کارشناسان داخلی و بین‌المللی
    <br />• پیگیری تخصصی و مستمر موضوعات داوری و آگاهی‌ بخشی و هماهنگی مستمر با
    طرفین
  </span>
);
const actuaries = (
  <span>
    با توجه به گسترش و پیشبرد علمی دانش نظری و کاربردی آمار در حوزه صنعت بیمه و
    بازارهای مالی و سایر حوزه های مرتبط در زمینه‌های علوم محاسبات بیمه و مالی و
    همچنین ضروریت امکان سنجی و طراحی محصولات بیمه ای و استفاده از داده کاوی و
    دیتا و بانک های اطلاعاتی خسارت و تحقیق و نوآوری وپژوهش در مورد ریسک های بیمه
    ای راه اندازی یک موسسه داده کاوی و اکچوئری طرح های بیمه ای، یک حلقه مفقوده
    در صنعت بیمه می باشد که ایرانیان پوشش با راه اندازی موسسه مستقلی بنام کنکاش
    ایرانیان با برند کنکاش بیمه با برخورداری از کادر مجرب بیمه‌ای و علمی و صاحب
    کرسی دانشگاهی در مرکز رشد واحدهای فناوری وکارآفرینی دانشگاه شهید بهشتی راه
    اندازی نمود و مدیر عامل و اکثراعضای اصلی هیات مدیره دکترین و هیات علمی این
    دانشگاه می باشند بی گمان، کنکاش ایرانیان به عنوان یک شرکت تحقیقاتی در حوزه
    بیمه، بانک و بورس و برخورداری از کادر مجرب بیمه ای، علمی و صاحب کرسی
    دانشگاهی می تواند تضمینی برای اجرای و انجام پژوهش های اثر گذار داشته باشد.
  </span>
);
const legal = (
  <span>
    شرکت‌های بیمه‌ای با مخاطرات زیادی به‌ویژه در بخش حقوقی مواجه هستند. بخشی از
    این مخاطرات به‌واسطه نارسایی‌هایی مانند کج منشی و کژ رفتاری از جانب
    بیمه‌گزاران و بخشی نیز به‌واسطه نارسایی‌های نهادی ایجاد می‌شوند. در واقع، به
    دلیل کمبود اطلاعات در مورد بیمه‌گزاران و موارد بیمه‌شده و همچنین نامتقارن
    بودن اطلاعات و یا بعضاً اطلاعات مخدوش شرکت‌های بیمه‌ای با زیان هایی در
    مبادلات بیمه‌ای مواجه خواهند شد. در مواردی نیز به دلیل کاستی‌های قانونی و
    نهادی و شرایط محیطی، اقتصادی و سیاسی شرکت‌های بیمه‌ای قادر به وصول مطالبات
    قانونی و حقوقی خود نیستند
    <br />
    ایرانیان پوشش بمنظور تسهیل خدمات حقوقی بیمه‌ای با راه انداری موسسه حقوقی و
    وکالت بیمه گران و اخذ پروانه رسمی موسسه از کانون وکلای دادگستری در صنعت بیمه
    جهت وکالت بیمه ای ، ریکاوری و اصل جانشینی ، قاعده نسبی و سایر مواردی که در
    قانون حقی برای بیمه گران پیش بینی شده باشد با وکالت از سوی بیمه گران در
    مراجع قضایی ، انتظامی، ثبتی اقدام می نماید .
  </span>
);
const audit = (
  <span>
    در کشور ما یکی از کلید موفقیت کسب و کار، مدیریت ریسک مالیات و بیمه تامین
    اجتماعی وجرایم و عواقب بعدی آن است سالانه خیلی از شرکت های بیمه ای با چالش
    جرایم سنگین قانونی مالیات ، تامین اجتماعی، اداره کار در گیر هستند و حتی شبکه
    فروشان آنها نمایندگان و کارگزاران و حتی ارزیابان ،اکچوئران حقیقی وحقوقی
    بخاطر تبعات آن، متاسفانه شغل خود را از دست داده اند گروه ایرانیان پوشش بعد
    از شناسائی این خلل وتهدید بزرگ صنعت بیمه با مشورت و همفکری از حسابداران خبره
    و مدیران وپیشکسوتان سازمان مالیاتی و تامین اجتماعی اقدام به راه اندازی موسسه
    خدمات حسابرسی و مشاوره مالیات وتامین اجتماعی نمود و در این راستا موسسه امین
    پوشش راه اندازی و تاسیس گردید و در حال حاضر خیلی از فعالین صنعت بیمه جامع
    ترین خدمات حسابداری را همراه با مشاوره مالی و مالیاتی را به ما برون سپاری
    کرده اند و حتی در بخش نمایندگان وکارگزاران حقوقي امین پوشش را بعنوان بازرس
    سال مالي معرفی نموده اند.
  </span>
);
const education = (
  <span>
    واقعیت آن است که با وجود چندین مرکز آموزشی و پژوهشی در کشور، ادبیات و دانش
    بیمه ای رونق چندانی پیدا نکرده و صنعت بیمه و بازارهای بیمه ای در کشور با
    مشکلات و چالش های متعددی مواجه است. بنابراین، ایجاد و تاسیس مراکز آموزشی و
    پژوهشی برای توسعه صنعت بیمه کشور و نهادینه کردن آن در جامعه و در زندگی
    اجتماعی مردم، اهمیت اساسی دارد. یکی از نارسایی های آموزش های بیمه ای آن است
    که این آموزش ها بیش تر رسمی هستند و نظریه ها و دیدگاه های نظری را در بر می
    گیرند. بنابراین، جای آموزش های کاربردی بیمه بویژه در حوزه ارزیابی خسارت و
    ارزیابی ریسک و حقوق بیمه ای خالی است. مراکز و آموزشگاه های بیمه ای بیش تر به
    آموزش های رسمی متعارف مشغول هستند و دانش پذیران را با نظریه ها و موضوعات
    نظری بیمه ای آشنا می کنند. ایرانیان پوشش با تاسیس آموزشگاه آزاد فنی وحرفه ای
    و موسسه علمی و پژوهشی اندیشکده بیمه در صدد است تا خلاء آموزش و پژوهش های
    کاربردی در کشور را پر کند و امکان تسهیم دانش بیمه ای بویژه دانش ضمنی
    کارشناسان و متخصصان بیمه را فراهم آورد. در واقع، ایرانیان پوشش درصدد است تا
    با ارائه آموزش ها و پژوهش های کاربردی بویژه در حوزه ارزیابی خسارت، ارزیابی
    ریسک، مسائل حقوقی مرتبط با بیمه و تسهیم و به مشارکت گذاشتن دانش ضمنی بیمه ای
    به توسعه و ترویج بیمه و نهادینه شدن آن در بین مردم کمک کند و در ضمن با تدارک
    آموزش حرفه ای و کاربردی به متقاضیان، دانش پذیران را برای ورود مستقیم به
    بازار کار کشور آماده سازد. به علاوه، اکثر پژوهش های بیمه ای در مراکز دولتی و
    با اولویت های خاصی انجام می شوند که با محدودیت های مالی و غیر مالی زیادی
    مواجه هستند.
  </span>
);
const valuationTwo = (
  <span>
    صاحبان اموال های بزرگ وکوچک بصورت آزاد جهت برآورد وارزش گذاری اموال از جمله
    کارخانه ، انبار، ساختمان مسکونی، تجاری، شرکت ، کارگاه، خودرو، کشتی، هواپیما،
    اسب و یا هراشیاء می تواند از ارزیابان وکارشناسان دادگستری زمان خرید ،فروش ،
    سرمایه گذاری، راست آزمایی یا شناسائی و برآورد استهلاک در خواست نمایند که
    گروه کارشناسان خبره شرکت ایده آل کسب وکار ایرانیان وابسته به شرکت ایرانیان
    پوشش با رعایت اصول محرمانگی، شفافیت، بی‌طرفی و اجتناب از تعارض منافع و بر
    اساس مطالعات بازار داخلی و بین‌المللی، تحلیل مالی، تجاری و اقتصادی و ارزیابی
    ابعاد فنآورانه و محاسبه ریسک (خطر)های مربوط و کیفیت و کمیت داده‌ها و
    اطلاعات، منبع، مستندات، هدف ارزش‌گذاری و روش‌های استفاده به طور مستند تشریح
    می نمایند .
  </span>
);
const valuation = (
  <span>
    متقاضیان ارزش گذاری در این بخش به دو دسته تقسیم می شوند دسته نخست برآورد
    قیمت جهت خرید بیمه نامه است برای خرید بیمه نامه ابتدا باید ارزش واقعی یک
    اموال مشخص گردد تا حق بیمه نامه درست محاسبه گردد و در صورت حادثه، کل خسارت
    جبران شود . وفق ماده 10 قانون بیمه درصورتی که مالی کمتر از قیمت واقعی بیمه
    شده باشد، بیمه‌گر فقط به تناسب مبلغ بیمه‌شده نسبت به قیمت واقعی مال، مسئول و
    متعهد به پرداخت خسارت خواهد بود و نکته مهم اینست که حتی شاید بعد از مدتی از
    شروع بیمه نامه ، ارزش اموال افزایش پیدا کرده باشد بیمه گذار در این حالت باید
    مجدد ارزش گذاری و جهت الحاقیه بیمه و پرداخت حق بیمه اضافی اقدام نمائید. در
    غیر اینصورت در صورت حادثه خسارت به تناسب سرمایه بیمه شده محاسبه ودر حق
    زیاندیده پرداخت می گردد.
  </span>
);
const safteyAssessment = (
  <span>
    اغلب حوادث، ناشی از فعالیت های انسانی و ماشینی قابل پیشگیری بوده و هر کدام
    از آنها علت مشخصی دارند. علل بوجود آمدن حوادث از قبیل نظارت ضعیف، آموزش
    ناکافی، نداشتن خط مشی ایمنی و… می باشد. اگر بتوان علت وقوع حادثه را حذف
    نمایید، توانسته اید از وقوع حادثه جلوگیری نمائید.
    <br />
    در این راستا شرکت ایرانیان پوشش با متخصصین ماهر و باتجربه در جهت افزایش
    ایمنی و اجنتاب از عواملی که می توان باعث مرگ و میر، جراحت، بیماری های شغلی،
    صدمه به تجهیزات و یا شرایطی که منابع انسانی ، مادی و معنوی را تهدید نماید با
    تحقیق های گسترده و ارائه دستورالعمل های تخصصی و کاربردی در خصوص حوادثی که می
    تواند محیط را تهدید نماید، جلوگیری بعمل آورده و روز بروز با توجه به تغییرات
    صورت پذیرفته در محیط شغلی، همیار بیمه گزارن خواهد بود.
  </span>
);
const riskAssessment = (
  <span>
    هر نوع فعالیتی در فرآیند اجرای خود می تواند با احتمال وقوع حوادث و یا
    مخاطراتی روبه رو شود که حاصل آن می‌تواند از برآورده شدن نتیجه و یا خواست
    مورد انتظار جلوگیری کنددر این میان احتمالی را که موجب گردیده تا بازده مورد
    نظر حاصل نشود را ریسک می‌نامند. این امر اشاره به وضعیت ناخوشایندی دارد که
    ممکن است فرد و یا سازمان در معرض آن قرار گرفته و باعث به وجود آمدن زیان
    گردد.
    <br />
    شرکت ارزیابان ایرانیان پوشش با کادری مجرب و متخصص در امور ارزیابی و تشخیص
    خطرات بالقوه و ریسک های پیش رو در ارتباط با انواع فعالیتها در راستای کاهش
    اثرات منفی، ضرر و زیان حاصل از آن، شانس و فرصت بهبود عملکرد و پیشنهاد
    استراتژی‌های مناسب اقدام می نماید که منجر به محافظت و جلوگیری از ضرر و زیان
    ناشی از خسارت به سرمایه های بیمه گذاران، شرکت های بیمه ای و در نتیجه سبب
    کاهش اثرات منفی آن می شود، مشاوره های ویژه ای در قالب موضوع های مورد تخصص
    ارائه می نماید.
  </span>
);
const damageAssessment = (
  <span>
    طبق آیین‌نامه ۸۵ مصوب شورای عالی بیمه، شرکت‌های ارزیابی خسارت بیمه‌ای، وظیفه
    بررسی و تحقیق در مورد علت بروز حادثه و تحقق خسارت، تعیین مقدار خسارت و تشخیص
    میزان تعهد بیمه‌‏گر طبق شرایط بیمه‌نامه و نیز مذاکره برای تعدیل و تسویه
    خسارت بیمه‌ای مورد ادعا را به عهده دارند. مشارکت‌ نکردن شرکت‌های بیمه، به هر
    عنوان در شرکت های ارزیابی خسارت بیمه‌ای، نبود رابطه استخدامی عضویت آنان در
    شرکت‌های بیمه (طبق ماده ۷ آیین‌نامه مذکور) و عدم نفع پذیری در سود حاصل از
    عملیات بیمه‌ای شرکت‌های بیمه، موجبات استقلال این گروه را در بررسی و ارزیابی
    خسارت بیمه‌ای فراهم نموده است. شرکت‌های بیمه و یا بیمه‌گذاران، جهت ارزیابی
    خسارت خود می‌توانند به شرکت ایرانیان پوشش از طریق راه های ارتباطی مراجعه
    نمایند و از خدمات این شرکت بهره‌مند گردند. این مهم، با توجه به اطلاع‌رسانی
    کلیه عوامل ذیربط و مرتبط میسر خواهد بود.
  </span>
);
const exampletext = (
  <span>
    <PlusCircleOutlined /> <span>مثال</span>
  </span>
);

const exampleValText = (
  <p className="textParagraph">
    فرض کنید شخصی کارخانه ای، انباری یا حتی خودرو خود را که 100 میلیون ریال ارزش
    دارد، به مبلغ 50 میلیون ریال بیمه می کند و خسارتی به مبلغ 10 میلیون ریال رخ
    می دهد. حال شرکت بیمه تمام خسارت را پرداخت نمی نماید زیرا ارزش خودرو نصف
    ارزش واقعی بیمه شده است و متعاقبا حق بیمه ای که می بایست از فرد دریافت می
    شده است، کمتر از حق بیمه واقعیست لذا بیمه گر خسارت پرداختی وی را برابر با
    فرمول زیر و مبلغ 5 میلیون ریال می پردازد: خسارت پرداختی = مبلغ خسارت واقع
    شده ضربدر سرمایه بیمه شده تقسیم بر سرمایه واقعی 5 میلیون ریال = (۱۰۰میلیون
    سرمایه واقعی / 50 میلیون سرمایه بیمه شده )* 10 میلیون ریال خسارت لازم به
    توضیح است که اکر کسی خودروی خود را در زمان صدرور بیمه نامه کاملا" به روز و
    واقعی بیمه کرده باشد، ولی در زمان حادثه ارزش خودرو بالاتر برود (مثلا خودرو
    گران شود) بازهم ماده 10 اعمال می شود. لذا در صورت افزایش قیمت مال، بیمه گذار
    می بایست شرکت بیمه را درجریان گذاشته و حق بیمه اضافی متعلقه پرداخت شود.
  </p>
);
const OurServicesTabs = (props) => {
  return props.size === "laptopdesktop" ? (
    <div className="ourServicesBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft">
            <strong> محصولات و نوآوری</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescription" style={{ color: "#fff" }}>
              معرفی خدمات ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "75px" }}>
        <Col span={2}></Col>
        <Col span={20}>
          <div class="container-tab">
            <ul class="accordion-tabs">
              <li class="tab-head-cont">
                <a href="#" class={props.tab == 12 ? "is-active" : " "}>
                  {<CustomTab image={serviceTwelve} />}
                </a>
                <section>
                  <TextTabs
                    title="THIRD PARTY AUTHORITY"
                    text={tpa}
                    size="laptopdesktop"
                  />
                </section>
              </li>
              <li class="tab-head-cont">
                <a href="#" class={props.tab == 11 ? "is-active" : " "}>
                  {<CustomTab image={serviceEleven} />}
                </a>
                <section>
                  <TextTabs
                    title="سامانه مشاوره"
                    text={counselingSystem}
                    size="laptopdesktop"
                  />
                </section>
              </li>
              <li class="tab-head-cont">
                <a href="#" class={props.tab == 10 ? "is-active" : " "}>
                  {<CustomTab image={serviceTen} />}
                </a>
                <section>
                  <TextTabs
                    title="تحقیق"
                    text={research}
                    size="laptopdesktop"
                  />
                </section>
              </li>
              <li class="tab-head-cont">
                <a href="#" class={props.tab == 9 ? "is-active" : " "}>
                  {<CustomTab image={serviceNine} />}
                </a>
                <section>
                  <TextTabs
                    title="داوری"
                    text={arbitration}
                    size="laptopdesktop"
                  />
                </section>
              </li>
              <li class="tab-head-cont">
                <a href="#" class={props.tab == 8 ? "is-active" : " "}>
                  {<CustomTab image={serviceEight} />}
                </a>
                <section>
                  <TextTabs
                    title="آکچوئری"
                    text={actuaries}
                    size="laptopdesktop"
                  />
                </section>
              </li>
              <li class="tab-head-cont">
                <a href="#" class={props.tab == 7 ? "is-active" : " "}>
                  {<CustomTab image={serviceSeven} />}
                </a>
                <section>
                  <TextTabs title="حقوقی" text={legal} size="laptopdesktop" />
                </section>
              </li>
              <li class="tab-head-cont">
                <a href="#" class={props.tab == 6 ? "is-active" : " "}>
                  {<CustomTab image={serviceSix} />}
                </a>
                <section>
                  <TextTabs title="حسابرسی" text={audit} size="laptopdesktop" />
                </section>
              </li>
              <li class="tab-head-cont">
                <a href="#" class={props.tab == 5 ? "is-active" : " "}>
                  {<CustomTab image={serviceFive} />}
                </a>
                <section>
                  <TextTabs
                    title="آموزش"
                    text={education}
                    size="laptopdesktop"
                  />
                </section>
              </li>
              <li class="tab-head-cont">
                <a href="#" class={props.tab == 4 ? "is-active" : " "}>
                  {<CustomTab image={serviceFour} />}
                </a>
                <section>
                  <TextTabs
                    title="ارزش گذاری"
                    text={valuation}
                    textTwo={valuationTwo}
                    example={exampletext}
                    exampleVal={exampleValText}
                    size="laptopdesktop"
                  />
                </section>
              </li>
              <li class="tab-head-cont">
                <a href="#" class={props.tab == 3 ? "is-active" : " "}>
                  {<CustomTab image={serviceThree} />}
                </a>
                <section>
                  <TextTabs
                    title="ارزیابی ایمنی"
                    text={safteyAssessment}
                    size="laptopdesktop"
                  />
                </section>
              </li>
              <li class="tab-head-cont">
                <a href="#" class={props.tab == 2 ? "is-active" : " "}>
                  {<CustomTab image={serviceTwo} />}
                </a>
                <section>
                  <TextTabs
                    title="ارزیابی ریسک"
                    text={riskAssessment}
                    size="laptopdesktop"
                  />
                </section>
              </li>
              <li class="tab-head-cont">
                <a href="#" class={props.tab == 1 ? "is-active" : ""}>
                  {<CustomTab image={serviceOne} />}
                </a>
                <section>
                  <TextTabs
                    title="ارزیابی خسارت"
                    text={damageAssessment}
                    size="laptopdesktop"
                  />
                </section>
              </li>
            </ul>
          </div>
        </Col>
        <Col span={2}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div className="ourServicesBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
          <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft">
            <strong> محصولات و نوآوری</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescriptionTablet" style={{ color: "#fff" }}>
              معرفی خدمات ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "75px" }}>
        <Col span={1}></Col>
        <Col span={22}>
          <Tabs
            defaultActiveKey={props.tab}
            onChange={callback}
            centered
            style={{ fontFamily: "IranSans", textAlign: "center" }}
          >
            <TabPane tab={<TabletMobileTab image={serviceOne} />} key="1">
              <TextTabs
                title="ارزیابی خسارت"
                text={damageAssessment}
                size="tablet"
              />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceTwo} />} key="2">
              <TextTabs
                title="ارزیابی ریسک"
                text={riskAssessment}
                size="tablet"
              />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceThree} />} key="3">
              <TextTabs
                title="ارزیابی ایمنی"
                text={safteyAssessment}
                size="tablet"
              />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceFour} />} key="4">
              <TextTabs
                title="ارزش گذاری"
                text={valuation}
                textTwo={valuationTwo}
                example={exampletext}
                exampleVal={exampleValText}
                size="tablet"
              />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceFive} />} key="5">
              <TextTabs title="آموزش" text={education} size="tablet" />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceSix} />} key="6">
              <TextTabs title="حسابرسی" text={audit} size="tablet" />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceSeven} />} key="7">
              <TextTabs title="حقوقی" text={legal} size="tablet" />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceEight} />} key="8">
              <TextTabs title="آکچوئری" text={actuaries} size="tablet" />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceNine} />} key="9">
              <TextTabs title="داوری" text={arbitration} size="tablet" />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceTen} />} key="10">
              <TextTabs title="تحقیق" text={research} size="tablet" />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceEleven} />} key="11">
              <TextTabs
                title="سامانه مشاوره"
                text={counselingSystem}
                size="tablet"
              />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceTwelve} />} key="12">
              <TextTabs
                title="THIRD PARTY AUTHORITY"
                text={tpa}
                size="tablet"
              />
            </TabPane>
          </Tabs>
        </Col>
        <Col span={1}></Col>
      </Row>
    </div>
  ) : (
    <div className="ourServicesBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
          <p className="mainTitleMobile mainTitleBorderRight mainTitleBorderLeft">
            <strong> محصولات و نوآوری</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescriptionMobile" style={{ color: "#fff" }}>
              معرفی خدمات ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "75px" }}>
        <Col span={1}></Col>
        <Col span={22}>
          <Tabs
            defaultActiveKey={props.tab}
            onChange={callback}
            centered
            style={{ fontFamily: "IranSans", textAlign: "center" }}
          >
            <TabPane tab={<TabletMobileTab image={serviceOne} />} key="1">
              <TextTabs title="ارزیابی خسارت" text={damageAssessment} />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceTwo} />} key="2">
              <TextTabs title="ارزیابی ریسک" text={riskAssessment} />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceThree} />} key="3">
              <TextTabs title="ارزیابی ایمنی" text={safteyAssessment} />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceFour} />} key="4">
              <TextTabs
                title="ارزش گذاری"
                text={valuation}
                textTwo={valuationTwo}
                example={exampletext}
                exampleVal={exampleValText}
              />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceFive} />} key="5">
              <TextTabs title="آموزش" text={education} />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceSix} />} key="6">
              <TextTabs title="حسابرسی" text={audit} />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceSeven} />} key="7">
              <TextTabs title="حقوقی" text={legal} />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceEight} />} key="8">
              <TextTabs title="آکچوئری" text={actuaries} />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceNine} />} key="9">
              <TextTabs title="داوری" text={arbitration} />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceTen} />} key="10">
              <TextTabs title="تحقیق" text={research} />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceEleven} />} key="11">
              <TextTabs title="سامانه مشاوره" text={counselingSystem} />
            </TabPane>
            <TabPane tab={<TabletMobileTab image={serviceTwelve} />} key="12">
              <TextTabs title="THIRD PARTY AUTHORITY" text={tpa} />
            </TabPane>
          </Tabs>
        </Col>
        <Col span={1}></Col>
      </Row>
    </div>
  );
};

export default OurServicesTabs;
